import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngResource from 'angular-resource';
import ngCookies from 'angular-cookies';

import 'angular-ui-bootstrap';

import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import 'angularjs-slider/dist/rzslider';

import 'bootstrap/dist/css/bootstrap.css';
import 'angular-material/angular-material.css';
import  ngFileUpload from 'ng-file-upload';
import 'normalize.css';
import './common/fonts/icons.styl';
import 'angular-recaptcha';
import 'angularjs-captcha'

import dynamicNumber from  'angular-dynamic-number';
import ngMaterial from 'angular-material';

angular.module('app', [
    dynamicNumber,
    ngMaterial,
    uiRouter,
    ngResource,
    ngFileUpload,
    'ui.bootstrap',
    'vcRecaptcha',
    'rzModule',
    'BotDetectCaptcha',
    Common,
    Components,
    ngCookies,
  ])
  .config(($cookiesProvider, $httpProvider, $locationProvider, captchaSettingsProvider) => {
    "ngInject";
    $cookiesProvider.defaults.secure = true;
    $cookiesProvider.defaults.samesite = 'none';
    $httpProvider.defaults.withCredentials = true;
    $locationProvider.html5Mode(true).hashPrefix('!');
    captchaSettingsProvider.setSettings({ captchaEndpoint: '/captcha/simple-captcha-endpoint' });
  })


  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js